import { render } from "./sglm-history.vue?vue&type=template&id=78394c5b&scoped=true"
import script from "./sglm-history.vue?vue&type=script&lang=js"
export * from "./sglm-history.vue?vue&type=script&lang=js"

import "./sglm-history.vue?vue&type=style&index=0&id=78394c5b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78394c5b"]])

export default __exports__